function EmailFilled({ className }: { className?: string }) {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.5 0C15.3281 0 16 0.671562 16 1.5C16 1.97187 15.7781 2.41562 15.4 2.7L8.6 7.8C8.24375 8.06563 7.75625 8.06563 7.4 7.8L0.6 2.7C0.222281 2.41562 0 1.97187 0 1.5C0 0.671562 0.671562 0 1.5 0H14.5ZM6.8 8.6C7.5125 9.13438 8.4875 9.13438 9.2 8.6L16 3.5V10C16 11.1031 15.1031 12 14 12H2C0.895313 12 0 11.1031 0 10V3.5L6.8 8.6Z"
        fill="white"
      />
    </svg>
  )
}

export default EmailFilled
